import React from 'react';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import styled from 'styled-components';
import CloseIcon from '../Icons/Close';

const StyledCloseButton = styled(IconButton)`
    position: absolute;
    right: 0px;
    padding-top: 8px !important;
    padding-right: 8px !important;
    color: #999999;
    &:hover {
        background-color: transparent;
    }
    &:focus {
        outline: none;
    }
    .close-icon {
        width: 32px !important;
        height: 32px !important;
    }
    .close-icon:hover {
        color: #718096;
    }
`;

/**
 * Close Button
 */
const CloseButton: React.FC<IconButtonProps> = ({ ...props }) => {
    return (
        <StyledCloseButton {...props}>
            <CloseIcon className="close-icon" data-testid="icon" aria-label="Close Dialog" />
        </StyledCloseButton>
    );
};

export default CloseButton;
